import apiClient from './apiClient'

/**
 * Utility API Service
 */

const utilityService = {

    // MARK: FETCH COMPANY INFO

    /**
     * Fetch company info
     * GET /company/info
     * 
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Company info
     */
    fetchCompanyInfo: async (options = {}) => {
        const response = await apiClient.get(
            '/campaigns',
            options
        )
        return response.data
    },

    // MARK: FETCH TAX REPORT

    /**
     * Fetch tax report
     * POST /campaigns/tax/report
     *
     * @param {string} taxyear - The tax year e.g. "2026"
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Tax report data
     */
    fetchTaxReport: async (taxyear, options = {}) => {
        const response = await apiClient.post(
            '/campaigns/tax/report',
            { taxyear },
            options
        )
        return response.data
    },

}

export default utilityService
